import React from 'react';
import {StatusBar} from 'react-native';

import {useTheme} from './ThemeContext';

/**
 * StatusBar that tracks the active theme ('dark-content' on light,
 * 'light-content' on dark). Replaces the hardcoded <StatusBar> in App.js;
 * renders identically while the default mode is light.
 */
export const ThemedStatusBar = () => {
  const {colors} = useTheme();
  return <StatusBar barStyle={colors.statusBarStyle} />;
};
